var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"tn-grid-item-class tn-grid-item",class:[
    _vm.backgroundColorClass
  ],style:({
    backgroundColor: _vm.backgroundColorStyle,
    width: _vm.gridWidth
  }),attrs:{"hover-class":_vm.hoverClass,"hover-stay-time":150},on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.click).apply(void 0, arguments)
}}},[_c('v-uni-view',{staticClass:"tn-grid-item__box"},[_vm._t("default")],2)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }